export default "__VITE_ASSET__CrHxl9Sb__"